import * as S from "./NoDataModule.style";

interface Props {
  title?: string;
  message: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

// 데이터가 없을 때 표출하는 공용 "No Data" 모듈
// (프로젝트 기존 에러 모듈 DataFormatErrorMessageContainer 와 동일 룩)
const NoDataModule = ({
  title = "No Data",
  message,
  buttonLabel,
  onButtonClick,
}: Props) => {
  return (
    <S.MessageWrapper>
      <S.Title>{title}</S.Title>
      <S.Line />
      <S.Message>{message}</S.Message>
      {buttonLabel && onButtonClick && (
        <S.Button type="button" onClick={onButtonClick}>
          {buttonLabel}
        </S.Button>
      )}
    </S.MessageWrapper>
  );
};

export default NoDataModule;
